import * as React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useAppDispatch } from "../../../store/hooks";
import { setAccountExternalId } from "../../../store/uiDataSlice";

type RouteParams = "id";

interface Props {}
export const BillingAccountCreateFirstWithId: React.FC<Props> = () => {
  const { id } = useParams<RouteParams>();
  const dispatch = useAppDispatch();
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    if (id) {
      dispatch(setAccountExternalId(id));
    }
    setIsReady(true);
  }, []);

  if (!isReady) {
    return null;
  }

  return <Navigate to={`/home/account/-create`} />;
};
